/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import "./PendingDsrAlert.css";

const REFRESH_INTERVAL = 5 * 60 * 1000;

const PendingDsrAlert = () => {
  const [dsrData, setDsrData] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const navigate = useNavigate();

  const getInitials = (name) => {
    if (!name) return "??";
    return name
      .split(" ")
      .filter((n) => n.length > 0)   
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const fetchPendingDsr = () => {
    const LoginToken = GetToken();
    if (!LoginToken) return;

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Projects/CheckPendingDsrForAdmin`,
    };

    axios(option)
      .then((res) => {
        const employees = res?.data?.data?.employees || [];  
        const count = res?.data?.data?.count || 0;           
        setDsrData(employees);
        setLastUpdated(new Date());
        if (count > 0) {
          setShowToast(true);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  useEffect(() => {
    fetchPendingDsr();
    const interval = setInterval(fetchPendingDsr, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   if (!showToast) return;
  //   const timer = setTimeout(() => setShowToast(false), 8000);
  //   return () => clearTimeout(timer);
  // }, [showToast]);

  const handleToastClick = () => {
    setShowToast(false);
    setShowModal(true);
  };

  if (dsrData.length === 0) return null;

  return (
    <>
      {/* ── Toast ── */}
      {showToast && (
        <div className="dsr-toast" onClick={handleToastClick}>
          <div className="dsr-toast-row1">
            <span className="dsr-toast-title">
              <span className="dsr-red-dot" />
              DSR Pending Alert
            </span>
            <span className="dsr-toast-time">just now</span>
            <button
              className="dsr-toast-close"
              onClick={(e) => {
                e.stopPropagation();
                setShowToast(false);
              }}
            >
              ×
            </button>
          </div>
          <p className="dsr-toast-sub">
            {dsrData.length} employee{dsrData.length !== 1 ? "s" : ""} haven't
            filled DSR for 2+ days
          </p>
          <p className="dsr-toast-cta">Click to view details →</p>
        </div>
      )}

      {/* ── Modal ── */}
      {showModal && (
        <div className="dsr-overlay" onClick={() => setShowModal(false)}>
          <div className="dsr-modal" onClick={(e) => e.stopPropagation()}>
            <div className="dsr-modal-head">
              <div>
                <h2>
                  Pending DSR —{" "}
                  <span className="dsr-count-text">
                    {dsrData.length} employee{dsrData.length !== 1 ? "s" : ""}
                  </span>
                </h2>
                <p>Employees missing Daily Status Reports (48+ hrs)</p>
              </div>
              <button
                className="dsr-modal-close"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>

            <div className="dsr-modal-body">
              {dsrData.map((emp, index) => (
                <div className="dsr-emp-row" key={index}>
                  <div className="dsr-avatar">
                    {getInitials(emp?.userName)}  
                  </div>
                  <div className="dsr-emp-info">
                    <p className="dsr-emp-name">{emp?.userName || "-"}</p>  
                    <p className="dsr-emp-since">
                      Since {emp?.sinceDate ? emp.sinceDate : "-"}          
                    </p>
                  </div>
                  <span className="dsr-badge">
                    {emp?.missingDays} {emp?.missingDays === 1 ? "day" : "days"} 
                  </span>
                </div>
              ))}
            </div>

            <div className="dsr-modal-foot">
              {/* <span>Auto-refreshes every 5 min</span> */}
              <span>
                Last updated:{" "}
                {lastUpdated ? moment(lastUpdated).format("hh:mm A") : "-"}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PendingDsrAlert;